import styled from 'styled-components';
import { layoutStyles } from './layout.styles';

export const PageWrap = styled.div`
  ${layoutStyles.pageWrap};
`;

